
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.712 11.161a.435.435 0 01-.205-.593.466.466 0 01.615-.198l9.317 4.496a1.64 1.64 0 001.42 0l9.318-4.496a.466.466 0 01.615.198.435.435 0 01-.205.593l-9.318 4.496c-.705.34-1.535.34-2.24 0l-9.317-4.496zm0 3.456a.435.435 0 01-.205-.593.466.466 0 01.615-.198l9.317 4.496a1.64 1.64 0 001.42 0l9.318-4.496a.466.466 0 01.615.198.435.435 0 01-.205.593l-9.318 4.496c-.705.34-1.535.34-2.24 0l-9.317-4.496zm0 3.457a.435.435 0 01-.205-.594.466.466 0 01.615-.198l9.317 4.496a1.64 1.64 0 001.42 0l9.318-4.496a.466.466 0 01.615.198.435.435 0 01-.205.594l-9.318 4.495c-.705.34-1.535.34-2.24 0l-9.317-4.495zM13.269 1.43l8.51 4.106a1.408 1.408 0 010 2.558L13.27 12.2c-.705.34-1.535.34-2.24 0L2.52 8.094a1.408 1.408 0 010-2.558l8.51-4.106a2.586 2.586 0 012.24 0zM2.93 6.328a.537.537 0 000 .975l8.51 4.107a1.64 1.64 0 001.42 0l8.51-4.107a.537.537 0 000-.975l-8.51-4.106a1.64 1.64 0 00-1.42 0L2.93 6.328z"}})])
          )
        }
      }
    